import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ServiceIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Service",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M28.14 29.28H3c-.36 0-.69-.17-.91-.45s-.29-.65-.2-.99l1.05-3.93c.4-1.5 1.76-2.54 3.31-2.54h18.62c1.55 0 2.91 1.04 3.31 2.54l1.05 3.93c.09.34.02.71-.2.99s-.55.45-.91.45ZM4.49 27h22.16l-.67-2.49c-.13-.5-.59-.85-1.1-.85H6.26c-.52 0-.97.35-1.1.85zM25.86 19c-.63 0-1.14-.51-1.14-1.14 0-5.04-4.1-9.14-9.14-9.14s-9.14 4.1-9.14 9.14a1.14 1.14 0 1 1-2.28 0c0-6.3 5.13-11.43 11.43-11.43s11.43 5.13 11.43 11.43c0 .63-.51 1.14-1.14 1.14ZM18.06 4.14h-4.99a1.14 1.14 0 1 1 0-2.28h4.99a1.14 1.14 0 1 1 0 2.28"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.57 8.71c-.63 0-1.14-.51-1.14-1.14V3a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14"
    })]
  }));
};
ServiceIcon.displayName = 'ServiceIcon';